var map = {
	"./DSC06310.jpg": 492,
	"./avatar.avif": 687,
	"./blog.png": 346,
	"./cluster.png": 964,
	"./ml-cluster.png": 332,
	"./portfolio.png": 372,
	"./pubman.png": 75,
	"./pubmanDetail.png": 263,
	"./react.png": 594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;